import '../App.css';
import '../scss/App.scss';
import { Box, Container, Grid, Link } from '@mui/material';
import React, {useEffect, useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import Content from '../layout/content-box/Content';
import Modal from 'bootstrap/js/dist/modal';

const { strength, schedulingList } = Content[0];

const testimonialSlides = [
   {
      id: 1,
      poster: '/assets/testimonial/video-poster1.svg',
      playIcon: '/assets/playIcon.png',
      video: '/assets/testimonial/testimonial1.mp4',
   },
   {
      id: 2,
      poster: '/assets/testimonial/video-poster2.svg',
      playIcon: '/assets/playIcon.png',
      video: '/assets/testimonial/testimonial2.mp4',
   },
   {
      id: 3,
      poster: '/assets/testimonial/video-poster3.svg',
      playIcon: '/assets/playIcon.png',
      video: '/assets/testimonial/testimonial4.mp4',
   },
];

const lockerVideos = [
  {
    id: 1,
    poster: '/assets/locker-video.svg',
    video: '/assets/locker-video.mp4',
  },
  {
    id: 2,
    poster: '/assets/locker-video.svg',
    video: '/assets/locker-video.mp4',
  },
  {
    id: 3,
    poster: '/assets/locker-video.svg',
    video: '/assets/locker-video.mp4',
  },
];
function Locker() {


   const [selectedVideo, setSelectedVideo] = useState(null);

   const handleOpenModal = (videoSrc) => {
      setSelectedVideo(videoSrc);
      setTimeout(() => {
         const modalElement = document.getElementById('videoModal');
         if (modalElement) {
            const modal = new Modal(modalElement);
            modal.show();
         }
      }, 100);
   };

   useEffect(() => {
  const modalElement = document.getElementById('videoModal');
  if (!modalElement) return;

  const bsModal = new Modal(modalElement);

  const handleModalHidden = () => {
    setSelectedVideo(null);  // Remove video from DOM, stops playback
  };

  modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

  // Cleanup event listener on unmount
  return () => {
    modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
  };
}, []);


    const [selectedVideoLocker, setSelectedVideoLocker] = useState(null);

  const handleOpenModalLocker = (videoSrc) => {
  setSelectedVideoLocker(videoSrc);
  setTimeout(() => {
    const modalElement = document.getElementById('lockerVideoModal');
    if (modalElement) {
      const modal = new Modal(modalElement); // Now Modal is defined
      modal.show();
    }
  }, 100);
};

useEffect(() => {
  const modalElement = document.getElementById('lockerVideoModal');

  if (modalElement) {
    const bsModal = new Modal(modalElement);

    const handleModalHidden = () => {
      setSelectedVideoLocker(null); // This unmounts the <video /> component and stops playback
    };

    modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
    };
  }
}, []);

   return (
      <>
         <Box className="aboutBanner lockerBanner" >
            <Container maxWidth="md">
               <Grid container spacing={2} justifyContent="left" alignItems="center">
                  <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                     <Box className="bannerText text-center">
                        <h1>{Content[0].lockerHeading}</h1>
                        <span>{Content[0].spanHeading}</span>
                        <p> {Content[0].paraHeading}</p>
                     </Box>
                  </Grid>
               </Grid>
            </Container>
         </Box>
         <section className="lockerBox founderBox lightGrayBox">
            <Container maxWidth="md">
               <Grid container spacing={3} justifyContent="left">
                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                     <Box className="aboutHeading mb-4">
                        <h2 >{Content[0].scheduleHeading}</h2>
                     </Box>
                     <Box className="rightIconList">
                        <ul>
                           {schedulingList.map((schedulingList, index) => (
                              <li>
                                 <CheckIcon />
                                 {schedulingList.point}
                              </li>
                           ))}
                        </ul>

                     </Box>
                     {/* <Box className="promoCode">
                           <h2 className='heading-h2 mt-4 mb-3'>Have a Promo code?</h2>
                           <form action="">
                              <Grid container spacing={2} justifyContent="center">
                                 <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                                    <Box className="promoButton">
                                       <div className="form-group mb-0">
                                          <input type="text" className="form-control" name="lastName" placeholder="Have a promo code?" />
                                       </div>
                                       <button className='btn btn-primary'>Submit</button>
                                    </Box>
                                 </Grid>
                              </Grid>
                           </form>
                        </Box> */}
                  </Grid>
                  {/* <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                     <Box className="lockerForm">
                        <form action="">
                           <Grid container spacing={2} justifyContent="left">
                              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                                 <div className="form-group mb-0">
                                    <label>Select nearby locker</label>
                                    <select className="form-select">
                                       <option>Jammu</option>
                                    </select>
                                 </div>
                              </Grid>
                              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                                 <div className="form-group mb-0">
                                    <label>To book Smart locker Via Whatsapp Scan Below QR</label>
                                    <select className="form-select">
                                       <option>Small</option>
                                    </select>
                                 </div>
                              </Grid>
                              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                                 <div className="form-group mb-0">
                                    <label>Number of Lockers</label>
                                    <select className="form-select">
                                       <option>1</option>
                                       <option>2</option>
                                       <option>3</option>
                                       <option>4</option>
                                       <option>5</option>
                                    </select>
                                 </div>
                              </Grid>
                              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                                 <div className="form-group">
                                    <label>Choose Date & Time</label>
                                    <input type="date" className="form-control" />
                                 </div>
                              </Grid>
                           </Grid>
                           <div className="mt-2 text-end">
                              <button className="btn btn-primary" type="submit">
                                 Procced to book
                              </button>
                           </div>
                        </form>
                     </Box>
                  </Grid> */}


                        {/*Qr Code Scetion to be added here*/}


         
<Grid container spacing={4} justifyContent="center" alignItems="center" style={{ marginTop: "20px" }}>
   
   {/* WhatsApp QR */}
   <Grid item xs={12} sm={5} md={4} style={{ textAlign: "center" }}>
   

      <p style={{ fontSize: "13px" }}>
      Scan to book Smartlocker <br />
      via WhatsApp
</p>
      <a href="https://wa.me/message/U4XVZQJLM5WBB1" target="_blank" rel="noopener noreferrer">
         <img
            src="assets/full-whatsapp.png"
            alt="WhatsApp QR"
            style={{
               width: "120px",
               height: "120px",
               objectFit: "contain"
            }}
         />
      </a>

      
   </Grid>

   {/* OR Divider */}
   <Grid item xs={12} sm={2} md={1}>
      <div style={{
         display: "flex",
         flexDirection: "column",
         alignItems: "center",
         justifyContent: "center",
         height: "100%"
      }}>
         {/* Top Line */}
         <div style={{
            width: "2px",
            height: "40px",
            background: "linear-gradient(to bottom, transparent, #ccc)"
         }} />

         {/* OR Text */}
         <span style={{
            margin: "8px 0",
            fontWeight: "600",
            color: "#666"
         }}>
            OR
         </span>

         {/* Bottom Line */}
         <div style={{
            width: "2px",
            height: "40px",
            background: "linear-gradient(to top, transparent, #ccc)"
         }} />
      </div>
   </Grid>

   {/* Web QR */}
   
   <Grid item xs={12} sm={5} md={4} style={{ textAlign: "center" }}>
     <p style={{ fontSize: "14px", marginTop: "0px" }}>
   Scan to book Smartlocker <br />via web portal</p>

      <a href="https://book.mandir.wiki/" target="_blank" rel="noopener noreferrer">
         <img
            src="assets/web.png"
            alt="Web QR"
            style={{
               width: "120px",
               height: "120px",
               objectFit: "contain"
            }}
         />
      </a>

      
   </Grid>

</Grid>

                        {/*Ends Here*/}

               </Grid>





            </Container>
         </section>
         
         <section>
            <Container maxWidth="md">
               <Grid container spacing={2} justifyContent="left" alignItems="center">
                  <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                     <h2 className='heading-h2 text-center'>Our Strengths & Where We Stand</h2>
                  </Grid>

                  {strength.map((strength) => (
                     <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                        <Box className="strengthBox">
                           <h3>{strength.id}</h3>
                           <p>{strength.text}</p>
                        </Box>
                     </Grid>
                  ))}
               </Grid>
            </Container>
         </section>



         <section className='pt-0'>
            <Container maxWidth="md">
               <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                     <h2 className='heading-h2 text-center'>{Content[0].testimonialHeading}</h2>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                     <div className='videoTestimonial'>
                        <img src="/assets/quotes1.png" alt="" className='img-fluid quote1' />
                        <img src="/assets/quotes2.png" alt="" className='img-fluid quote2' />

                        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
                           <div className="carousel-indicators">
                              {testimonialSlides.map((_, index) => (
                                 <button
                                    key={index}
                                    type="button"
                                    data-bs-target="#carouselExampleIndicators"
                                    data-bs-slide-to={index}
                                    className={index === 0 ? "active" : ""}
                                    aria-current={index === 0 ? "true" : undefined}
                                    aria-label={`Slide ${index + 1}`}
                                 ></button>
                              ))}
                           </div>

                           <div className="carousel-inner">
                              {testimonialSlides.map((slide, index) => (
                                 <div key={slide.id} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                                    <div
                                       className="videoImgBox"
                                       style={{ cursor: 'pointer' }}
                                       onClick={() => handleOpenModal(slide.video)}
                                    >
                                       <img src={slide.poster} className="img-fluid" alt={`poster-${index + 1}`} />
                                       <img src={slide.playIcon} className="img-fluid playIcon" alt="Play icon" />
                                    </div>
                                 </div>
                              ))}
                           </div>

                           <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                              <span className="visually-hidden">Previous</span>
                           </button>
                           <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                              <span className="carousel-control-next-icon" aria-hidden="true"></span>
                              <span className="visually-hidden">Next</span>
                           </button>
                        </div>

                        {/* Modal placed outside carousel */}
                        <div className="modal fade" id="videoModal" tabIndex="-1" aria-labelledby="videoModalLabel" aria-hidden="true">
                           <div className="modal-dialog modal-dialog-centered modal-lg">
                              <div className="modal-content">
                                 <div className="modal-header">
                                    <h5 className="modal-title" id="videoModalLabel">Testimonial</h5>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                 </div>
                                 <div className="modal-body">
                                    {selectedVideo && (
                                       <video controls className="w-100">
                                          <source src={selectedVideo} type="video/mp4" />
                                          Your browser does not support the video tag.
                                       </video>
                                    )}
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </Grid>


               </Grid>
            </Container>
         </section>




         <section >
            <Container maxWidth="md">
               <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                     <h2 className='heading-h2 text-center'>{Content[0].videoHeading}</h2>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                     <div className="videoTestimonial">
      <img src="/assets/quotes1.png" alt="" className="img-fluid quote1" />
      <img src="/assets/quotes2.png" alt="" className="img-fluid quote2" />

      <div id="carouselExampleIndicators1" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-indicators lockerIndecator">
          {lockerVideos.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#carouselExampleIndicators1"
              data-bs-slide-to={index}
              className={index === 0 ? 'active' : ''}
              aria-current={index === 0 ? 'true' : undefined}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>

        <div className="carousel-inner">
          {lockerVideos.map((video, index) => (
            <div
              key={video.id}
              className={`carousel-item ${index === 0 ? 'active' : ''}`}
            >
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => handleOpenModalLocker(video.video)}
              >
                <img
                  src={video.poster}
                  className="img-fluid w-100"
                  alt={`poster-${index + 1}`}
                />
                <img
                  src="/assets/playIcon.png"
                  alt="Play Icon"
                  className="playIcon"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '60px',
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators1"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators1"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>

      {/* Video Modal */}
      <div
        className="modal fade"
        id="lockerVideoModal"
        tabIndex="-1"
        aria-labelledby="lockerVideoModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="lockerVideoModalLabel">Locker Video</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {selectedVideoLocker && (
                <video controls className="w-100" autoPlay>
                  <source src={selectedVideoLocker} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>

                  </Grid>


               </Grid>
            </Container>
         </section>

         <section className="lockerBox founderBox lightGrayBox">
            <Container maxWidth="md">
               <Grid container spacing={3} alignItems="center">
                  <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                     <Box className="aboutHeading mb-4">
                        <h2 >Smart Locker Booking  Steps</h2>
                        <p>Reserve your Locker in Minutes</p>
                        <a href="../assets/pdf/guide-pdf.pdf" target='_blank' className='btn btn-primary'>View Guide</a>
                        <Link href="contact-us" className='btn btn-outline-primary ms-3 text-decoration-none'>Enquire Now</Link>
                     </Box>

                  </Grid>
                  <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                     <Box className="lockerImg">
                        <img src="../assets/lockerimg.svg" className='img-fluid' alt="" />
                     </Box>
                  </Grid>

               </Grid>





            </Container>
         </section>
         
      </>
   );
}
export default Locker;